import { CallMade } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GenConfirmationDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

export default function OrderConfirmDialog({
  open,
  onClose,
  onConfirm,
  order,
  processingAction,
}) {
  const { t } = useTranslation(['orders', 'global']);
  return (
    <GenConfirmationDialog
      open={open}
      onClose={onClose}
      onRefuse={onClose}
      onConfirm={onConfirm}
      disabled={processingAction}
      title={t('workApproved')}
      closeText={t('close', { ns: 'global' })}
      confirmText={t('workQueue')}
      confirmStartIcon={<CallMade />}
    >
      <Grid container direction={'column'} alignItems="center">
        <Grid item>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginBottom="20px"
          >
            <Typography variant="overline">{t('vinNumber')}:</Typography>
            <Typography variant="subtitle" marginLeft={'7.5px'}>
              {order?.vehicle?.vin}
            </Typography>
          </Box>
          <Typography variant="Body1">{t('goToWorkQueue')}</Typography>
        </Grid>
      </Grid>
    </GenConfirmationDialog>
  );
}
